<template>
  <div class="d-flex align-items-center">
    <i
      v-if="iconClass"
      :class="iconClass"
      class="fa-2x mr-2"
    />
    <div class="d-flex flex-column">
      <p
        v-if="title"
        class="mb-0"
      >
        {{ title }}
      </p>
      <p
        v-if="subtitle"
        class="mb-0 text-small text-light text-nowrap"
      >
        {{ subtitle }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OperationsOption',
  props: {
    title: { type: String },
    subtitle: { type: String },
    iconClass: { type: String },
  },
};
</script>

<style scoped>
</style>
